const messages = {
    availPoints: "Dostępne punkty",
    awaitingPoints: "Oczekujące punkty",
  board: {
    title: "Pulpit",
    title2: "Animacja wydajności {year}",
    headline1: "Twoje promocje i punkty w jednym miejscu",
    headline2: "Zdobywaj punkty za zakupy opon.",
    pointsBalanceToDate: "SALDO PUNKTÓW NA DZIEŃ",
    availPoints: "Dostępne punkty",
    awaitingPoints: "Oczekujące punkty",
    yourRealisation: "TWOJE WYNIKI",
    yourEngagement: "Twoje roczne zobowiązanie: <b>{tyres} opon</b>",
    yourPoints: "TWOJE PUNKTY",
    yourRetailPurchase: "TWOJE ZAKUPY DETALICZNE",
    yourRetailPurchaseCCS: "TWOJA SPRZEDAŻ DETALICZNA",
    pointsByPurchase: "punkty wygenerowane przez Twoje zakupy",
    pointsByBoosters: "punkty wygenerowane przez boostery",
    pointsByBSPurchase: "Punkty wygenerowane przez Twoje zakupy Bridgestone",
    pointsByBSPurchaseCCS:
      "Punkty wygenerowane przez sprzedaż opon Bridgestone",
    remaining: "Pozostałe opony",
    yourGoal: "Postęp celu",
    unit: "opon",
    buttons: {
      learnMore: "Dowiedz się więcej o swoich punktach",
      learnMoreAboutMechanism: "Dowiedz się więcej o mechanizmie",
    },
    charts: {
      byBrand: "Według marki",
      bySize: "Według<br/>rozmiaru felgi",
    },
    exploreResults: "Poznaj swoje wyniki",
    tyreLimitInfo:
      "W każdej edycji akcji Booster wymagany jest minimalny wolumen sell-out 50 opon marek Bridgestone i/lub Firestone.",
  },
  charts: {
    byBrand: "Według marki",
    bySize: "według rozmiaru felgi",
  },

  dashboard: {
    dashboardTitle: "Twoje korzyści",
    dashboardBox: {
      title: "Saldo punktów",
      description: "Aktualna liczba Twoich punktów marketingowych",
      availPoints: "Dostępne punkty",
      awaitingPoints: "Oczekujące punkty",
      lastUpdate: "Ostatnia aktualizacja",
      button: "Dowiedz się więcej",
      points: "punkty",
    },
  },
  soldTyres: "SPRZEDANE OPONY",
  receivedPoints: "ZDOBYTE PUNKTY",
  boosterCCS: {
    personalInfo: "Dane osobowe",
    csNumberTitle: "Podaj uczestniczący(e) numer(y) konta",
    tyresTitle: "Podaj liczbę sprzedanych opon",
    minTyresInfo:
      "Wymagane minimum to {tyres} opon Bridgestone/Firestone. Wynagrodzenie dotyczy wyłącznie opon Bridgestone.",
    tyresAmount: "Liczba opon",
    filesTitle: "Prześlij dokumenty potwierdzające sprzedaż",
    filesDescription:
      "Uwaga: uwzględniane będą tylko sprzedaże z podanym rozmiarem felgi opon.",
    addAnotherFile: "Dodaj kolejny dokument",
    file: "Prześlij dokument",
    formatInfo:
      "Akceptowane formaty plików: xlsx, jpeg i pdf. Maksymalny rozmiar pliku: 8 MB",
    confrimationMessage:
      "<b>Dziękujemy za udział!</b> <br/>Twoje zgłoszenie zostało przyjęte i przekazane zespołowi Bridgestone do weryfikacji.<br/>Otrzymasz powiadomienie e-mail z wynikiem udziału w akcji Booster CCS.<br/>Do zobaczenia w Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Udostępnij punkty",
    forShare: "Punkty, które udostępnisz",
    title: "Tytuł",
  },
  notFoundFile: "Nie wybrano pliku",
  chooseFile: "Wybierz plik",
};
export default {
  messages,
};
